/**
 * @param {string} [tag]
 */
export function normalizeTag(tag) {
  if (tag == null || tag === "") return "";
  return String(tag)
    .trim()
    .toLowerCase();
}

/**
 * @param {string[]|null|undefined} palavrasChave
 */
function normalizeKeywordList(palavrasChave) {
  if (!Array.isArray(palavrasChave)) return [];
  return palavrasChave.map(k => normalizeTag(k)).filter(Boolean);
}

/**
 * @param {object} item
 * @param {string} queryLower
 */
function matchesSearchQuery(item, queryLower) {
  if (!queryLower) return true;
  const fields = [item.descricao, item.resumo, item.conteudo].map(f =>
    f != null ? String(f).toLowerCase() : ""
  );

  if (fields.some(f => f.includes(queryLower))) return true;

  const keywords = normalizeKeywordList(item.palavras_chave);
  return keywords.some(k => k.includes(queryLower));
}

/**
 * @param {object} item
 * @param {string|null|undefined} activeTag
 */
function matchesActiveTag(item, activeTag) {
  const tag = normalizeTag(activeTag);
  if (!tag) return true;
  const keywords = normalizeKeywordList(item.palavras_chave);
  return keywords.includes(tag);
}

/**
 * @param {object[]} items
 * @param {{ searchQuery?: string, activeTag?: string|null }} [filters]
 */
export function filterNovidadesList(items, filters = {}) {
  const list = Array.isArray(items) ? items : [];
  const queryLower = (filters.searchQuery || "").trim().toLowerCase();
  const activeTag = filters.activeTag;

  return list.filter(
    item =>
      matchesSearchQuery(item, queryLower) && matchesActiveTag(item, activeTag)
  );
}

/**
 * Tags únicas ordenadas alfabeticamente a partir do acumulado carregado.
 * @param {object[]} items
 */
export function extractUniqueTags(items) {
  const list = Array.isArray(items) ? items : [];
  const set = new Set();
  list.forEach(item => {
    normalizeKeywordList(item.palavras_chave).forEach(k => set.add(k));
  });
  return Array.from(set).sort((a, b) => a.localeCompare(b, "pt-BR"));
}

const RECENT_WINDOW_MS = 48 * 60 * 60 * 1000;

/**
 * @param {string|Date} dataPublicacao
 * @param {number} [nowMs]
 */
export function isNovidadeRecente48h(dataPublicacao, nowMs = Date.now()) {
  if (!dataPublicacao) return false;
  const published = new Date(dataPublicacao).getTime();
  if (Number.isNaN(published)) return false;
  return nowMs - published <= RECENT_WINDOW_MS && published <= nowMs;
}

/**
 * ids de novidades publicadas nas últimas 48 horas.
 * @param {object[]} items
 * @param {number} [nowMs]
 */
export function resolveRecentNovidadeIds(items, nowMs = Date.now()) {
  const list = Array.isArray(items) ? items : [];
  return list
    .filter(item => isNovidadeRecente48h(item.data_publicacao, nowMs))
    .map(item => item.idnovidade)
    .filter(id => id != null);
}

/**
 * idnovidade do release mais recente no acumulado (API ordena desc).
 * @param {object[]} items
 */
export function resolveLatestNovidadeId(items) {
  const list = Array.isArray(items) ? items : [];
  if (list.length === 0) return null;
  return list[0].idnovidade != null ? list[0].idnovidade : null;
}

export const NOVIDADES_PAGE_SIZE = 20;
